<template>
  <div class="login_wrap"> 
    <div class="login_content" v-show="isTrue">
      <div class="reset_success">
        <div><img src="../../../assets/img/success.png" style="width:86px;height:86px; margin-bottom: 20px;" alt="" /></div>
        <div class="success_text"  style="margin-bottom: 20px;width: 220px;">恭喜，密码修改成功！</div>
        <div><el-button type="primary" round style="width: 220px;height: 46px;font-size: 16px;" @click="toLogin"> 重 新 登 陆</el-button></div>
      </div>
    </div>
    <div class="login_content" v-show="!isTrue">
      <div class="login_title">修改登录密码</div>   
      <div class="login_tips">【新密码规则】 必须是由大写字母，小写字母，数字，以及特殊字符@_.\-#$%!组成，且长度不少于8位；</div>
      <div class="login_form">
        <el-form :model="ruleForm" :rules="rules" status-icon ref="ruleForm" size="medium" label-width="100px"
          class="demo-ruleForm">
          <el-form-item label="旧密码" prop="oldPass">
            <el-input :type="oldPassType" v-model="ruleForm.oldPass" autocomplete="off">
              <i slot="suffix" v-if="oldPassType !== 'password'" class="el-input__icon iconfont iconzhengyan"
                style="cursor: pointer; font-size: 20px; color: #2d99d7" @click="showOldPwd"></i>
              <i slot="suffix" v-if="oldPassType === 'password'" class="el-input__icon iconfont iconbiyan1"
                style="cursor: pointer; font-size: 20px" @click="showOldPwd"></i>
            </el-input>
          </el-form-item>
          <!-- <el-form-item label="验证码" prop="code">
            <el-input v-model="ruleForm.code" autocomplete="off" style="width:160px;"></el-input>
            <el-button type="primary" round>获取验证码</el-button>
          </el-form-item> -->
          <el-form-item label="新密码" prop="pass">
            <el-input :type="passwordType" v-model="ruleForm.pass" autocomplete="off">
              <i slot="suffix" v-if="passwordType !== 'password'" class="el-input__icon iconfont iconzhengyan"
                style="cursor: pointer; font-size: 20px;color:#2D99D7;" @click="showPwd"></i>
              <i slot="suffix" v-if="passwordType === 'password'" class="el-input__icon iconfont iconbiyan1"
                style="cursor: pointer; font-size: 20px;" @click="showPwd"></i>
            </el-input>
          </el-form-item>
          <el-form-item label="确认新密码" prop="checkPass">
            <el-input :type="checkPasswordType" v-model="ruleForm.checkPass">
              <i slot="suffix" v-if="checkPasswordType !== 'password'" class="el-input__icon iconfont iconzhengyan"
                style="cursor: pointer; font-size: 20px;color:#2D99D7;" @click="showPwdCheck"></i>
              <i slot="suffix" v-if="checkPasswordType === 'password'" class="el-input__icon iconfont iconbiyan1"
                style="cursor: pointer; font-size: 20px;" @click="showPwdCheck"></i>
            </el-input>
          </el-form-item>
          <el-form-item class="bottom_form">
            <el-button type="primary" round style="width:280px;" @click="submitForm('ruleForm')"> 确认</el-button>
          </el-form-item>
        </el-form>
      </div> 
      <div class="login_tips2 "> [当前账号信息]：{{routerPrams.sysuser?routerPrams.sysuser:""}}-{{routerPrams.calName?routerPrams.calName:""}}-{{routerPrams.calCode?routerPrams.calCode:""}} </div>    
    </div> 
  </div>
</template>

<script>
import request from '@/utils/request';
export default {
  data() {
    var checknewpass = (rule, value, callback) => {
      if (value == '') {
        callback(new Error('请输入新密码'));
      } else if (!this.checkedPassWordDreg(value)) {
        //引入methods中封装的检查手机格式的方法
        callback(new Error('新密码不符合规则，请重新根据规则输入;'));
      } else {
        callback();
      }
    };
    var checknewpass2 = (rule, value, callback) => {
      if (value == '') {
        callback(new Error('请再次输入新密码'));
      } else if (value !== this.ruleForm.pass) {
        callback(new Error('两次新密码输入不一致，请重新检查后输入;'));
      } else if (!this.checkedPassWordDreg(value)) {
        //引入methods中封装的检查手机格式的方法
        callback(new Error('新密码不符合规则，请重新根据规则输入;'));
      } else {
        callback();
      }
    };
    return {
      isTrue: false,
      checked: false,
      routerPrams: {},
      oldPassType: 'password',
      checkPasswordType: 'password',
      passwordType: 'password',
      ruleForm: {
        oldPass: '',
        pass: '',
        checkPass: ''
      },
      rules: {
        // iphone: [{ required: true, validator: checkphone, trigger: 'blur' }],
        oldPass: [{ required: true, message: '请输入旧密码', trigger: 'blur' }],
        pass: [{ required: true, validator: checknewpass, trigger: 'blur' }],
        checkPass: [{ required: true, validator: checknewpass2, trigger: 'blur' }]
      }
    };
  },
  mounted() {
    this.routerPrams = this.$route.query;
  },

  methods: {
    //检查手机号
    isCellPhone(val) {
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(val)) {
        return false;
      } else {
        return true;
      }
    },
    // 校验新密码
    checkedPassWordDreg(value) {
      const passwordreg = /^(?=.{8})(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d)(?=.*?[_.\-#$%!@]).*$/;
      const isValid = passwordreg.test(value);
      if (isValid !== true) {
        return false
      } else {
        return true
      }
    },
    showOldPwd() {
      if (this.oldPassType === 'password') {
        this.oldPassType = '';
      } else {
        this.oldPassType = 'password';
      }
    },
    showPwdCheck() {
      if (this.checkPasswordType === 'password') {
        this.checkPasswordType = '';
      } else {
        this.checkPasswordType = 'password';
      }
    },
    showPwd() {
      if (this.passwordType === 'password') {
        this.passwordType = '';
      } else {
        this.passwordType = 'password';
      }
    },
    remberPassword(val) {
      console.log(val);
    },
    toLogin() {
      this.$router.push('/login');
    },
    submitForm() {
      const that = this;
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          // this.$message.success('设置成功');
          // this.isTrue = true;
          const params = {
            ...that.routerPrams,
            syspassold:that.ruleForm.oldPass,
            syspassnew:that.ruleForm.pass,
            syspassnew1:that.ruleForm.checkPass,
          };
          const personType = {
            category: 'XuXiZhi'
          };
          request
            .post('/login/modifyPassByChannelAccount ', params, personType)
            .then((res) => {
              // console.log("密码修改返回值:", res)
              if(res.success){
               that.isTrue = true;
              }else{
                that.$message.error(res.errMsg ? res.errMsg:"修改出错请联系管理员;");
              }             
            })
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.login_wrap {
  position: relative;
  background: #f1faff;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  // border: 1px solid red;
  display: flex;
  justify-content: center;
  align-items: center;

  .login_content {
    width: 850px;
    height: 500px;
    background: #ffffff;
    box-shadow: 0px 5px 50px 0px rgba(186, 186, 186, 0.5);
    border-radius: 35px;
    padding: 30px 30px;
    position: relative;

    .reset_success {
      width: 120px;
      height: 200px;
      margin: 100px auto;
      display: flex;
      justify-content: center;
      flex-wrap: wrap;

      .success_text {
        width: 100%;
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 600;
        color: #333333;
        text-align: center;
      }
    }

    .login_title {
      width: 100%;
      font-size: 20px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #2d99d7;
      text-align: center;
      border-bottom: 1px solid #f0f0f0;
      padding-bottom: 30px;
    }

    .login_tips {
      font-size: 14px;
      color: red;
      text-align: center;
      margin-top: 5px;
    }
     .login_tips2{
      font-size: 14px;
      color: rgb(187, 183, 183);
      text-align: center;
      margin-top: 5px;
      position: absolute;
      bottom: 0;
     }
    .login_form {
      width: 400px;
      height: 320px;
      box-sizing: border-box;
      // border: 1px solid red;
      margin-top: 30px;
      margin-left: 180px;

      ::v-deep .el-input--medium .el-input__inner {
        height: 45px !important;
        line-height: 45px !important;
        // border-radius: 0 10px 10px 0;
      }

      ::v-deep .el-button--medium {
        height: 45px !important;
        margin-left: 10px;
      }
    }
  }
}
</style>
